import React from 'react'
import "./Notifications.css"
import NotificationBoxes from '../../components/NotificationBoxes/NotificationBoxes'

const Notification = () => {
  return (
    <NotificationBoxes/>
  )
}

export default Notification